import { type Reducer } from 'react';
import * as uuid from 'uuid';

import { type AdvancedFiltersReducerActions } from './types/reducer.types';
import { type AdvancedFiltersPrivateState } from './types/state.types';
import {
  advancedFilterConditionIsComplete,
  assignUuidToAdvancedFilterConditions,
} from './utilities/reducer-utils';

export const advancedFiltersReducer: Reducer<
  AdvancedFiltersPrivateState,
  AdvancedFiltersReducerActions
> = (state, action) => {
  const { type } = action;

  switch (type) {
    case 'CHANGE_COMBINE_MODE': {
      const { payload } = action;
      return {
        ...state,
        conditionCombineMode: payload.condition,
      };
    }
    case 'ADD_CONDITION': {
      const { payload } = action;
      const rowId = uuid.v4();

      return {
        ...state,
        conditions: {
          ...state.conditions,
          [rowId]: { ...payload },
        },
      };
    }
    case 'REMOVE_CONDITION': {
      const { payload } = action;
      const nextConditions = { ...state.conditions };
      delete nextConditions[payload.rowId];
      return {
        ...state,
        conditions: nextConditions,
      };
    }
    case 'PATCH_CONDITION': {
      const { payload } = action;
      const nextPatchedCondition = {
        ...state.conditions[payload.rowId],
        ...payload.condition,
      };
      return {
        ...state,
        conditions: {
          ...state.conditions,
          [payload.rowId]: nextPatchedCondition,
        },
      };
    }
    case 'FLUSH_NEW_ADVANCED_FILTERS': {
      const { payload } = action;
      return {
        conditionCombineMode: payload.conditionCombineMode,
        conditions: assignUuidToAdvancedFilterConditions(
          payload.conditions.filter((condition) =>
            advancedFilterConditionIsComplete(condition),
          ),
        ),
      };
    }
    case 'REMOVE_INCOMPLETE_ROWS': {
      const completeConditions = Object.fromEntries(
        Object.entries(state.conditions).filter(([, condition]) =>
          advancedFilterConditionIsComplete(condition),
        ),
      );
      return {
        ...state,
        conditions:
          Object.keys(completeConditions).length > 0
            ? completeConditions
            : assignUuidToAdvancedFilterConditions([{}]),
      };
    }
    case 'RESET': {
      return {
        conditionCombineMode: 'and',
        conditions: assignUuidToAdvancedFilterConditions([{}]),
      };
    }
    default:
      return state;
  }
};
